module.exports = __webpack_public_path__ + "img/jingli.2cd1ac1d.png";